import React, { useState } from "react";
import NavigationBar from "./NavigationBar";
import { AppContainer, RowView, ToastContainer } from "./Styled";
import LeftNav from "./LeftNav";
import Content from "./Content";
import { ThemeProvider } from "@mui/material";
import theme from "../theme";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import { Toast } from "./Toast";
import { Login } from "../widgets/Login";
import { useAuthStatus } from "../hooks/useAuthStatus";
import { AuthenticationProvider } from "../provider/AuthenticationProvider";
import ForgotPassword from "../widgets/ForgotPassword";
import ResetPassword from "../widgets/ResetPassword";
import ChangePasswordPage from "../widgets/ChangePassword";

function App() {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const { isSignedIn, setIsSignedIn } = useAuthStatus();

    return (
        <AuthenticationProvider setLoggedIn={setIsSignedIn}>
            <ThemeProvider theme={theme}>
                <Router>
                    {isSignedIn ? (
                        <AppContainer>
                            <NavigationBar setIsCollapsed={setIsCollapsed} />
                            <RowView>
                                <LeftNav isCollapsed={isCollapsed} />
                                <Content />
                            </RowView>
                            <Toast />
                        </AppContainer>
                    ) : (
                        <ToastContainer>
                            <Toast />
                            <Routes>
                                <Route path="/forgot-password" element={<ForgotPassword />} />
                                <Route path="/reset-password/:token" element={<ResetPassword />} />
                                <Route path="/login" element={<Login setIsSignedIn={setIsSignedIn} />} />
                                <Route path="/change-password" element={<ChangePasswordPage />} />
                                <Route path="*" element={<Navigate to="/login" replace />} />
                            </Routes>
                        </ToastContainer>
                    )}
                </Router>
            </ThemeProvider>
        </AuthenticationProvider>
    );
}

export default App;
